export default __webpack_public_path__ + "static/icons-90faa2c50e283307d6a381de8e1d64fb.svg";